import Layout from "layout";
import IPageConfig from "rules/interface/config/config.interface";

// default path on "/" url
export const DefaultPageConfig: IPageConfig = {
  title: "طراحی و سفارش آنلاین کابینت و کمد دیواری",
  layout: Layout,
  config: {
    header: {
    }
  },
};

// Main page path on "/" url
export const MainPageConfig: IPageConfig = {
  title: "طراحی و سفارش آنلاین کابینت و کمد دیواری",
  layout: Layout,
  config: {
    header: {
    }
  },
};

// Product page path on "/product" url
export const ProductPageConfig: IPageConfig = {
  layout: Layout,
  backgroundColor: "#fff",
  config: {
    header: {
      onlyLogo: true,
    },
    footer: {
      hide: false
    }
  },
};

// Cabinet ads landing page path on "/cabinet-ads-landing" url
export const CabinetAdsPageConfig: IPageConfig = {
  layout: Layout,
  config: {
    header: {
      onlyLogo: true,
    },
    footer: {
      // onlyConsultingNum: true,
      // soical: {
      //   onlyPintressAndAparat: true
      // }
    }
  },
};

// Tabriz landing page path on "/tabriz-landing" url
export const TabrizPageConfig: IPageConfig = {
  layout: Layout,
  config: {},
  backgroundColor: "#fff"
};

// Mashad landing page path on "/mashad-landing" url
export const MashadPageConfig: IPageConfig = {
  layout: Layout,
  config: {},
  backgroundColor: "#fff"
};

// Models page path on "/models" url
export const ModelsPageConfig: IPageConfig = {
  title: "مدل ها و نمونه کارهای کابینت و دکوراسیون | سلام ساختمان",
  layout: Layout,
  config: {},
};

// Model page path on "/model/[id]" url
export const ModelPageConfig: IPageConfig = {
  layout: Layout,
  config: {
    header: {
      backBtn: true
    }
  },
};

// contractors page path on "/special-contractors" url
export const specialContractorsPageConfig: IPageConfig = {
  layout: Layout,
  config: {
    footer: {
      hide: false
    }
  },
};

// contractors page path on "/Contractors" url
export let SpecialistsPageConfig: IPageConfig = {
  layout: Layout,
  config: {
    footer: {
      hide: false
    }
  },
};


// specialist page path on "/Contractors/[id]" url
export const ContractorPageConfig: IPageConfig = {
  layout: Layout,
  config: {
    header: {
      backBtn: true
    }
  },
};

// workshop page path on "/workshop/[id]" url
export const WorkShopPageConfig: IPageConfig = {
  layout: Layout,
  config: {},
};

// packages page path on "/packages" url
export const packagesPageConfig: IPageConfig = {
  layout: Layout,
  config: {},
};

// specialist page path on "/contractors-signup/" url
export const SpecialistsSignup: IPageConfig = {
  layout: Layout,
  config: {},
};

// specialist page path on "/cabinet-maker-signup/" url
export const CabinetMakerSignup: IPageConfig = {
  layout: Layout,
  config: {},
};

// About-us page path on "/about-us" url
export const AboutUsPageConfig: IPageConfig = {
  layout: Layout,
  config: {
    header: {
      onlyLogo: true,
    },
  },
};

// Rules page path on "/rules" url
export const RulesPageConfig: IPageConfig = {
  layout: Layout,
  config: {
    header: {
      onlyLogo: true,
    },
  },
};

// Builders-Signup page path on "/builders-signup" url
export const BuildersSignupPageConfig: IPageConfig = {
  layout: Layout,
  config: {
    header: {
      onlyLogo: true,
    },
  },
};

// assembler page path on "/assemblers" url
export const AssebmlersPageConfig: IPageConfig = {
  layout: Layout,
  config: {},
};

// assembler profile page path on "/assemblers/[id]" url
export const AssebmlersProfilePageConfig: IPageConfig = {
  layout: Layout,
  backgroundColor: "#FFF",
  config: {},
};
